import React from 'react';
import { CheckCircleIcon } from '../../assets/icons';

const VERIFF_URL = 'https://www.veriff.com/';
const SUPPORT_EMAIL = 'hello@hansepay.com';

function VerificationLinkSent() {
  return (
    <div className='min-h-screen bg-background flex items-center justify-center p-4'>
      <div className='max-w-md w-full rounded-lg border bg-card text-card-foreground shadow-sm'>
        <div className='flex flex-col space-y-1.5 p-6 text-center'>
          <div className='mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-success/10'>
            <CheckCircleIcon className='h-8 w-8 text-success' aria-hidden />
          </div>
          <h3 className='font-semibold tracking-tight text-2xl'>Verification Link Sent</h3>
          <p className='text-muted-foreground text-base mt-2'>Check your inbox to continue</p>
        </div>
        <div className='p-6 pt-0 space-y-4 text-center'>
          <p className='text-muted-foreground leading-relaxed'>
            We&apos;ve sent you a verification link via email. Click the link in your inbox to start the identity verification process with our
            partner{' '}
            <a href={VERIFF_URL} target='_blank' rel='noopener noreferrer' className='text-primary hover:underline font-medium'>
              Veriff
            </a>
            .
          </p>
          <div className='rounded-lg bg-muted/50 p-4 text-sm text-muted-foreground'>
            Didn&apos;t receive the email? Check your spam folder or contact us at{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`} className='text-primary hover:underline'>
              {SUPPORT_EMAIL}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerificationLinkSent;
